<template>
  <div
    class="Fuell-Table"
    ref="table"
    v-if="!isLoading"
  >
    <div class="Fuell-Table--header">
      <div class="Fuell-Table--item">
        <span>{{ $t('company_export_settings_file_format_name') }}</span>
      </div>
      <div class="Fuell-Table--item">
        <span>{{ $t('company_export_settings_file_format_author') }}</span>
      </div>
      <div class="Fuell-Table--item">
        <span>{{ $t('company_export_settings_file_format_format') }}</span>
      </div>
      <div class="Fuell-Table--item">
        <span>{{ $t('company_export_settings_file_format_used') }}</span>
      </div>
      <div class="Fuell-Table--item"><span></span></div>
    </div>

    <file-format-table-row
      v-for="fileFormat in fileFormats"
      @editFileFormat="editFileFormat"
      @removeFileFormat="removeCategory"
      :fileFormat="fileFormat"
      :key="fileFormat.id"
    ></file-format-table-row>
    <div
      class="w-100 d-flex justify-content-center"
      v-if="isRemoving"
    >
      <spinner />
    </div>
  </div>
  <div
    class="w-100 h-100 d-flex justify-content-center align-items-center"
    v-else
  >
    <spinner></spinner>

  </div>
</template>

<script>
import Spinner from '@/components/Commons/Spinner'
import FileFormatTableRow from './FileFormatTableRow'
import _paginationHandlerMixin from '@/components/Commons/_mixins/_paginationHandlerMixin'

export default {
  name: 'FileFormatTable',
  components: { FileFormatTableRow, Spinner },
  mixins: [_paginationHandlerMixin],
  data () {
    return {
      isLoading: false,
      isRemoving: false
    }
  },

  computed: {
    fileFormats () {
      return this.$store.getters['CompanyStore/ExportSettingsStore/fileFormats']
    },
    currentPage () {
      return this.$store.getters['CompanyStore/ExportSettingsStore/fileFormatsCurrentPage']
    },
    lastPage () {
      return this.$store.getters['CompanyStore/ExportSettingsStore/fileFormatsLastPage']
    }
  },
  methods: {
    nextPage () {
      this.$store.dispatch('CompanyStore/ExportSettingsStore/nextFileFormatsPage')
    },
    editFileFormat (event) {
      this.$emit('editFileFormat', event)
    },
    async removeCategory (event) {
      if (!event) return
      this.isRemoving = true
      await this.$store.dispatch('CompanyStore/ExportSettingsStore/deleteFileFormat', event)
      this.isRemoving = false
    },

    async fetchFileFormats () {
      await this.$store.dispatch('CompanyStore/ExportSettingsStore/fetchFileFormats', { pagination: true })
    }
  },
  async created () {
    this.isLoading = true
    await this.fetchFileFormats()
    this.isLoading = false
  }
}
</script>

<style lang="scss" scoped>
.Fuell-Table--header,
.Fuell-Table--row {
  grid-template-columns: 200px 160px 100px minmax(300px, 1fr) 24px;
  width:auto;
}
</style>
<style scoped>
.Fuell-Table {
  overflow-x:hidden;
  overflow-y:auto;
  height:auto;
  padding-bottom: 100px;
}
</style>
